import { BLOCK_REFERENCE_COLUMNS, NOT_BLOCK_REFERENCE_COLUMNS, } from './rows-block-references.js';
/**
 * The block-reference registry (baseline section 3 "Block references"; 1.0b deliverable 4). A
 * move re-homes every registered reference; a vanished block flags every registered reference.
 * 1.0a's migration test proves that the database holds no other `*block_id` column.
 */
export { BLOCK_REFERENCE_COLUMNS, NOT_BLOCK_REFERENCE_COLUMNS, };
/** The column names that store a block id by name: `block_id` and `*_block_id`. */
export const BLOCK_ID_COLUMN = /(^|_)block_id$/;
const listed = new Set([...BLOCK_REFERENCE_COLUMNS, ...NOT_BLOCK_REFERENCE_COLUMNS].map((c) => `${c.table}.${c.column}`));
/**
 * Every column whose name stores a block id (`(^|_)block_id$`) and that neither
 * {@link BLOCK_REFERENCE_COLUMNS} nor {@link NOT_BLOCK_REFERENCE_COLUMNS} lists, in input order.
 * 1.0a's migration test calls it with the columns of base tables only: a view's column (`edge_v`'s
 * `block_id`, a copy of `mention.block_id`) stores nothing of its own.
 */
export function findUnregisteredBlockColumns(columns) {
    return columns.filter((c) => BLOCK_ID_COLUMN.test(c.column) && !listed.has(`${c.table}.${c.column}`));
}
//# sourceMappingURL=block-references.js.map